import { Tag } from 'src/services/tag/Tag';
import { getTagSummary } from './getTagSummary';

export function getSummaryIcon<T extends Tag>(tag: T, tags: T[]): string {
  const summary = getTagSummary(tag, tags);
  switch (summary) {
    case 'runningBalance':
      return 'balance';
    case 'expenditureProgress':
      return 'shopping_bag';
    case 'incomeProgress':
      return 'savings';
    default:
      return 'tag';
  }
}
